/**
 * this should probably get assigned to a team, but for now
 * @owner @Appboy/frontend-ix
 * @scaffoldversion 0.0.0
 */

import { RootComponent } from "./RootComponent";
export default RootComponent;
